import { Stack, Typography } from '@mui/material';
import NoteTooltip from './NoteTooltip';
import StatusButton from './StatusButton';
import { SummaryValue } from './summary/SummaryValue';

// Sized and padded to match the policy and catalog cards it sits beside, so the status button here
// lines up with their action buttons.
const STATUS_BUTTON_SX = {
  fontSize: '0.72rem',
  fontWeight: 600,
  textTransform: 'none',
  py: 0.25,
  minHeight: 0,
  minWidth: 0,
  flexShrink: 0,
};

// The editable half of a details page header: what the thing is called, how this environment has
// judged it, and the note explaining why. The status button is also the way in to editing both.
// Anything that only exists because of the status, such as what a trusted app is made of, follows
// the note. A card whose body is given over to that keeps the note as an icon beside the name, and
// titleAdornment puts anything else that belongs beside the name after it. actions sit just before
// the status button, for what the status makes possible.
const EntityStatusCard = ({
  name,
  status,
  note,
  onEdit,
  disabledEdit = false,
  noteInTitle = false,
  titleAdornment = null,
  actions = null,
  children,
  sx,
}) => (
  <Stack
    sx={{
      backgroundColor: '#454545',
      border: '1px solid #5B5B5B',
      borderRadius: '8px',
      p: 1.5,
      ...sx,
    }}
    gap={1}>
    <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1}>
      <Stack direction="row" alignItems="center" gap={0.75} sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            color: '#FFFFFF',
            fontWeight: 700,
            fontSize: '0.82rem',
            lineHeight: 1.3,
            minWidth: 0,
            wordBreak: 'break-word',
          }}>
          {name || '—'}
        </Typography>
        {noteInTitle ? <NoteTooltip note={note} size={15} /> : null}
        {titleAdornment}
      </Stack>
      <Stack direction="row" alignItems="center" gap={1} flexShrink={0}>
        {actions}
        <StatusButton
          status={status}
          size="small"
          disabled={disabledEdit}
          onClick={onEdit}
          sx={STATUS_BUTTON_SX}
        />
      </Stack>
    </Stack>

    {noteInTitle ? null : (
      <SummaryValue label="Note" compact>
        {note || 'No note available'}
      </SummaryValue>
    )}

    {children}
  </Stack>
);

export default EntityStatusCard;
